import React, { useState } from "react";
import { useSelector } from "react-redux";
import messages from "../../assets/locale/messages";
import Button from "../../components/Button";
import ProgramsList from "./ProgramsList/ProgramsList";
import AddIcon from "@material-ui/icons/Add";
import ProgramForm from "./ProgramForm/ProgramForm";

import Title_Section from "../../components/Title_Section/Title_Section";

export default function Programs() {
  const lang = useSelector((state) => state.locale.lang);
  const {
    programs: { title, addTitle }
  } = messages[lang];
  const [addModalOpen, setFormModalOpen] = useState(false);
  const [formMode, setFormMode] = useState({
    mode: "add",
    editId: 0
  });

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <Title_Section title={title} />
        <Button
          text={addTitle}
          icon={<AddIcon className="me-2" />}
          onClick={() => {
            setFormModalOpen(true);
            setFormMode({ mode: "add", editId: 0 });
          }}
        />
      </div>
      <ProgramsList />
      <ProgramForm
        mode={formMode}
        setFormModalOpen={setFormModalOpen}
        isOpen={addModalOpen}
      />
    </div>
  );
}
